import {baseEnvironment} from './environment.base';
export const environment = {
  ...baseEnvironment,
  API_URL: '/devEnvUrl',
  dev: true,
  encryptLocalStorage: true,
  encryptLocalStorageKey: 'f74808fb03f94ef8f64350a37918c1b0518c',
  baseUrl: 'https://qa.pcarelink.com/api/v1',
  instamed: {
    hostname: 'https://pay.instamed.com/',
    manual: false
  },
  openEdge: {
    payFieldsApiKey: '1Z86l8MtfJmz5ao7aG6mFBgn6FoKGKTy',
    environment: 'test',
    enableAutocomplete: true
  },
  host: 'https://qa.pcarelink.com',
  paymentHost: 'https://payqa.pcarelink.com',
  inventoryURL: 'https://app.vaxintrack.com/admin/home/inventory',
  docUrl: 'https://docs.pcarelink.com/'
};